/*
  Galerie-Messung (VS-20261004-001, Aufgabe gallery-messung, Yin 2026-10-04): welche Bilder der
  Produktgalerie Kundinnen wirklich gesehen haben, ob das letzte Bild erreicht wurde und ob alle
  Bilder der gerade gezeigten Gruppe gesehen wurden. Meldet an Microsoft Clarity. Alles Weitere
  (Lesart, Nenner, Grenzen, Pruefstand, Rueckbau): docs/GALLERY-MESSUNG.md.

  Ein Bild zaehlt als gesehen (einmal je Produkt, Bild-ID und Seitenaufruf), wenn gleichzeitig
    - das Bild selbst geladen ist (complete und naturalWidth > 0; Ladefehler zaehlt nie),
    - mindestens 50 % SEINER Flaeche im Fenster liegen (gemessen am Bild, nicht am Rahmen;
      bei object-fit contain am tatsaechlich gemalten Bildteil; Abschneiden durch Scroll-
      Container zaehlt; wer hoeher als zwei Fensterhoehen ist, kann 50 % nie erreichen und
      zaehlt dann nie),
    - und davon nach Abzug fremder Ebenen (Popup, Kopfleiste, Warenkorb) noch 50 % der Bild-
      flaeche frei sind (8x8 Stichpunkte im sichtbaren Teil per elementFromPoint; Bedienelemente
      der eigenen Galerie bzw. der Zoom-Ansicht gelten nicht als fremd),
    - die Seite sichtbar ist (visibilityState visible),
    - und das alles ununterbrochen 1 Sekunde lang. Geprueft wird im Takt von 250 ms, solange Bilder
      im Fenster sind; zusaetzlich bricht jede IntersectionObserver-Meldung unter 50 % (oder mit
      nicht mehr erfuellter Pruefung) die laufende Sekunde sofort ab, auch wenn das Bild vor dem
      naechsten Takt zurueck ist. Was IO nicht sieht (Ebene, Zoom-Verschiebung kuerzer als 250 ms),
      kann zwischen zwei Takten durchrutschen.
  Gemessen wird nur die Hauptgalerie der Produktseite (<product-gallery data-viv-messung>, das
  Attribut setzen nur sections/main-product*.liquid), nur Bilder (keine Videos, 3D-Modelle,
  Vorschaubildchen) und in der Zoom-Ansicht (PhotoSwipe) das gerade gezeigte Bild — das meldet
  eine nur lesende Bruecke in assets/theme.js als Event "viv:galerie-zoom".

  "Alle Bilder" = die Bilder, die die Galerie gerade wirklich zeigen kann (nicht hidden, mit
  Layout), unterschieden nach der Menge ihrer Media-IDs. Eine leere Gruppe wird nie fertig. Nach
  einem Gruppenwechsel (Variante, Neuaufbau) beginnt jede Sekunde neu: fertig wird eine Gruppe
  nur durch ein echtes Sehen in ihr, nie durch das Umschalten allein. Dieselbe Gruppe meldet
  hoechstens einmal.

  Clarity (Namen, wie Yin sie sieht):
    Events (sitzungsweit, NICHT je Produkt): 图库-进入, 图库-图片曝光, 图库-末图曝光, 图库-全部图片曝光
    Tags   (Wert = Produkt-Handle, damit A und B nicht vermischt werden):
           图库-进入 = <handle>, 图库-末图 = <handle>, 图库-全部 = <handle>,
           图库-图片 = <handle>|<Media-ID>  (welches Bild; je Bild einmal),
           图库-张数 = <handle>|NN  (NN = wie viele verschiedene Bilder bis dahin gesehen; NICHT die
                                    Position des Bildes; jede Stufe einmal)

  Einwilligung: nur mit Shopify.customerPrivacy.analyticsProcessingAllowed() === true wird
  beobachtet, gezaehlt, gepuffert oder gesendet. Shopify / loadFeatures / customerPrivacy duerfen
  spaeter kommen: bis zu 60 x 250 ms wird nachgesehen, loadFeatures (consent-tracking-api 0.1)
  einmal gerufen und die Einwilligung gelesen, sobald die API da ist; bis dahin passiert nichts.
  visitorConsentCollected startet die Sekunde neu. Ein Widerruf beendet sofort Beobachtung und
  laufende Sekunden und verwirft alles noch nicht an Clarity Uebergebene (samt Zaehlstand dafuer);
  schon Uebergebenes bleibt bis Seitenende gezaehlt, eine erneute Einwilligung zaehlt dort weiter.
  Dieses Skript erteilt nie selbst eine Einwilligung. Keine Cookies, kein localStorage, keine
  Formular-, Kunden- oder URL-Daten, kein eigener Server.
  Fehler: jeder Einstieg steht in try/catch. Ein Fehler schaltet nur die Messung ab (lieber keine
  Daten als falsche), nie die Galerie oder den Kauf.
  Live-Pruefung: window.VIV_GALERIE_MESSUNG.version / .zustand(); jede Meldung zusaetzlich als
  DOM-Event "viv:galerie-messung" am document.
*/
(function () {
  'use strict';
  if (window.VIV_GALERIE_MESSUNG) return;

  var VERSION = '2026-10-04b';
  var ANTEIL = 0.5;
  var DAUER_MS = 1000;
  var TAKT_MS = 250;
  var RASTER = 8;
  var PUFFER_MAX = 100;
  var PUFFER_VERSUCHE = 30;
  var PUFFER_ABSTAND_MS = 2000;
  var API_VERSUCHE = 60;
  var API_ABSTAND_MS = 250;

  var EVENT = {
    eintritt: '图库-进入',
    bild: '图库-图片曝光',
    letztes: '图库-末图曝光',
    alle: '图库-全部图片曝光'
  };
  var TAG = {
    eintritt: '图库-进入',
    letztes: '图库-末图',
    alle: '图库-全部',
    bild: '图库-图片',
    anzahl: '图库-张数'
  };

  var erlaubt = false;
  var kaputt = false;
  var io = null;
  var takt = null;
  var gruppenTimer = null;
  var galerien = [];
  var bildZuGalerie = new Map();
  var kandidaten = new Map();
  var produkte = {};
  var gesendet = {};
  var puffer = [];
  var pufferTimer = null;
  var pufferVersuche = 0;
  var pufferAufgegeben = false;
  var featuresAngefragt = false;
  var apiVersuche = 0;
  var apiTimer = null;
  var zaehler = { gesendet: 0, gepuffert: 0, verworfen: 0 };

  window.VIV_GALERIE_MESSUNG = {
    version: VERSION,
    zustand: function () {
      var p = {};
      Object.keys(produkte).forEach(function (h) {
        p[h] = {
          gesehen: Object.keys(produkte[h].gesehen),
          letztesGruppen: Object.keys(produkte[h].letztesGruppen).length,
          alleGruppen: Object.keys(produkte[h].alleGruppen).length
        };
      });
      return {
        version: VERSION,
        erlaubt: erlaubt,
        kaputt: kaputt,
        galerien: galerien.map(function (g) {
          return { handle: g.handle, gruppe: g.gruppeIds.slice(), letzte: g.letzteId, bilder: g.bilder.length };
        }),
        beobachtet: bildZuGalerie.size,
        kandidaten: kandidaten.size,
        takt: !!takt,
        produkte: p,
        puffer: puffer.length,
        apiWarten: !!apiTimer,
        zaehler: { gesendet: zaehler.gesendet, gepuffert: zaehler.gepuffert, verworfen: zaehler.verworfen }
      };
    }
  };

  function jetzt() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }

  // Ein Fehler hier darf nie nach aussen dringen; er schaltet nur die Messung ab.
  function sicher(fn) {
    return function () {
      if (kaputt) return;
      try {
        return fn.apply(this, arguments);
      } catch (e) {
        kaputt = true;
        try { abbauen(); } catch (x) {}
      }
    };
  }

  // ---------------------------------------------------------------- Einwilligung

  function einwilligung() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) {
      return false;
    }
  }

  function apiDa() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function');
    } catch (e) {
      return false;
    }
  }

  // Shopify, loadFeatures und customerPrivacy koennen nach diesem Skript kommen. Begrenzt warten
  // (API_VERSUCHE x API_ABSTAND_MS): sobald loadFeatures da ist, einmal die consent-tracking-api
  // anfordern; sobald customerPrivacy da ist, die Einwilligung lesen. Bis dahin wird nichts
  // beobachtet, gezaehlt oder gepuffert. Kommt die API nie, bleibt nur der visitorConsentCollected-Weg.
  var apiNachladen = sicher(function () {
    apiTimer = null;
    if (apiDa()) {
      pruefeEinwilligung(false);
      return;
    }
    if (!featuresAngefragt && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      featuresAngefragt = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], sicher(function (fehler) {
          if (fehler) return;
          pruefeEinwilligung(true);
        }));
      } catch (e) {}
      if (apiDa()) {
        pruefeEinwilligung(false);
        return;
      }
    }
    apiVersuche += 1;
    if (apiVersuche < API_VERSUCHE) apiTimer = setTimeout(apiNachladen, API_ABSTAND_MS);
  });

  var pruefeEinwilligung = sicher(function (neuStart) {
    var ja = einwilligung() && !pufferAufgegeben;
    if (ja && !erlaubt) {
      erlaubt = true;
      starten();
    } else if (!ja && erlaubt) {
      abbauen();
    } else if (ja && neuStart) {
      sekundenNeu();
      galerienSuchen();
      planen(0);
    }
  });

  // ---------------------------------------------------------------- Senden

  function clarityRufen(args) {
    try {
      window.clarity.apply(window, args);
    } catch (e) {}
  }

  function pufferLeeren() {
    if (!puffer.length || typeof window.clarity !== 'function') return;
    if (!einwilligung()) {
      abbauen();
      return;
    }
    var liste = puffer;
    puffer = [];
    liste.forEach(function (x) { clarityRufen(x.args); });
    zaehler.gesendet += liste.length;
  }

  // Nicht Uebergebenes verwerfen und so tun, als waere es nie passiert: Senden-Marke weg, Zaehlstand
  // zurueck. Uebergebenes bleibt bis zum Ende des Seitenaufrufs gezaehlt. Der Puffer ist immer das
  // juengste Ende der Meldungen (es wird nur in Reihenfolge uebergeben), darum rueckwaerts.
  function pufferVerwerfen() {
    for (var i = puffer.length - 1; i >= 0; i -= 1) {
      delete gesendet[puffer[i].schluessel];
      if (puffer[i].rueck) puffer[i].rueck();
    }
    zaehler.verworfen += puffer.length;
    puffer = [];
  }

  var pufferWarten = sicher(function () {
    pufferTimer = null;
    pufferLeeren();
    if (!puffer.length) return;
    pufferVersuche += 1;
    if (pufferVersuche >= PUFFER_VERSUCHE) {
      // Clarity kam nicht: begrenzt warten, dann verwerfen statt ewig halten. Danach misst dieser
      // Seitenaufruf nicht mehr (sonst koennten spaeter Bild-/Fertig-Tags ohne 进入 ankommen).
      pufferAufgegeben = true;
      abbauen();
      return;
    }
    pufferTimer = setTimeout(pufferWarten, PUFFER_ABSTAND_MS);
  });

  // true = an Clarity uebergeben oder (begrenzt, mit Einwilligung) gepuffert; false = verworfen,
  // dann muss der Aufrufer seinen Zaehlstand selbst zuruecknehmen.
  function melden(schluessel, args, rueck) {
    if (gesendet[schluessel]) return true;
    if (!einwilligung()) {
      abbauen();
      return false;
    }
    if (typeof window.clarity === 'function') {
      pufferLeeren();
      if (!erlaubt) return false;
      clarityRufen(args);
      zaehler.gesendet += 1;
    } else if (!pufferAufgegeben && puffer.length < PUFFER_MAX) {
      puffer.push({ schluessel: schluessel, args: args, rueck: rueck || null });
      zaehler.gepuffert += 1;
      if (!pufferTimer) pufferTimer = setTimeout(pufferWarten, PUFFER_ABSTAND_MS);
    } else {
      zaehler.verworfen += 1;
      return false;
    }
    gesendet[schluessel] = 1;
    try {
      document.dispatchEvent(new CustomEvent('viv:galerie-messung', {
        detail: { art: args[0], name: args[1], wert: args.length > 2 ? args[2] : null }
      }));
    } catch (e) {}
    return true;
  }

  function event(name, schluessel, rueck) {
    return melden('e|' + schluessel, ['event', name], rueck);
  }

  function tag(name, wert) {
    return melden('t|' + name + '|' + wert, ['set', name, wert]);
  }

  // ---------------------------------------------------------------- Galerien

  function produkt(handle) {
    if (!produkte[handle]) {
      produkte[handle] = { gesehen: {}, anzahl: 0, letztesGruppen: {}, alleGruppen: {} };
    }
    return produkte[handle];
  }

  function bildVon(slide) {
    var img = slide.firstElementChild;
    while (img && img.tagName !== 'IMG') img = img.nextElementSibling;
    return img || null;
  }

  function gruppeLesen(g) {
    var ids = [];
    var bilder = [];
    var kinder = g.liste.children;
    for (var i = 0; i < kinder.length; i += 1) {
      var s = kinder[i];
      if (!s.classList || !s.classList.contains('product-gallery__media')) continue;
      if (s.getAttribute('data-media-type') !== 'image') continue;
      if (s.hidden || s.closest('[hidden]') || !s.getClientRects().length) continue;
      var id = s.getAttribute('data-media-id');
      var img = bildVon(s);
      if (!id || !img) continue;
      ids.push(id);
      bilder.push(img);
    }
    return { ids: ids, bilder: bilder, schluessel: ids.slice().sort().join(',') };
  }

  function gruppeAktualisieren(g) {
    var neu = gruppeLesen(g);
    if (neu.schluessel === g.gruppe && g.bilder.length === neu.bilder.length &&
        g.bilder.every(function (b, i) { return b === neu.bilder[i]; })) {
      return;
    }
    var wechsel = neu.schluessel !== g.gruppe;
    g.bilder.forEach(function (b) {
      if (neu.bilder.indexOf(b) === -1) {
        if (io) io.unobserve(b);
        bildZuGalerie.delete(b);
        kandidaten.delete(b);
      }
    });
    neu.bilder.forEach(function (b) {
      if (!bildZuGalerie.has(b)) {
        bildZuGalerie.set(b, g);
        if (io) io.observe(b);
      }
    });
    g.bilder = neu.bilder;
    g.gruppe = neu.schluessel;
    g.gruppeIds = neu.ids;
    g.letzteId = neu.ids.length ? neu.ids[neu.ids.length - 1] : null;
    if (wechsel) {
      // Neue Gruppe: keine mitgebrachte Sekunde, fertig nur durch neues Sehen.
      kandidaten.forEach(function (k) {
        if (k.galerie === g) {
          k.seit = null;
          k.erledigt = false;
        }
      });
    }
    planen(0);
  }

  var gruppenPlanen = sicher(function () {
    if (gruppenTimer) return;
    gruppenTimer = setTimeout(sicher(function () {
      gruppenTimer = null;
      if (!erlaubt) return;
      galerien.slice().forEach(function (g) {
        if (!g.el.isConnected || !g.liste.isConnected) {
          loesen(g);
        } else {
          gruppeAktualisieren(g);
        }
      });
    }), 50);
  });

  function binden(el) {
    var handle = el.getAttribute('data-viv-produkt-handle');
    var liste = el.querySelector('media-carousel');
    if (!handle || !liste) return;
    var g = {
      el: el,
      liste: liste,
      handle: handle,
      bilder: [],
      gruppe: null,
      gruppeIds: [],
      letzteId: null,
      mo: null,
      zoomBild: null
    };
    g.mo = new MutationObserver(gruppenPlanen);
    g.mo.observe(liste, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    g.beimLaden = sicher(function (e) {
      if (bildZuGalerie.has(e.target) || e.target === g.zoomBild) planen(0);
    });
    g.beimZoom = sicher(function (e) {
      zoomMelden(g, e.detail || {});
    });
    el.addEventListener('load', g.beimLaden, true);
    el.addEventListener('error', g.beimLaden, true);
    el.addEventListener('viv:galerie-zoom', g.beimZoom);
    galerien.push(g);
    gruppeAktualisieren(g);
    event(EVENT.eintritt, 'eintritt|' + handle);
    tag(TAG.eintritt, handle);
  }

  function loesen(g) {
    if (g.mo) g.mo.disconnect();
    g.el.removeEventListener('load', g.beimLaden, true);
    g.el.removeEventListener('error', g.beimLaden, true);
    g.el.removeEventListener('viv:galerie-zoom', g.beimZoom);
    g.bilder.forEach(function (b) {
      if (io) io.unobserve(b);
      bildZuGalerie.delete(b);
    });
    kandidaten.forEach(function (k, b) {
      if (k.galerie === g) kandidaten.delete(b);
    });
    g.bilder = [];
    var i = galerien.indexOf(g);
    if (i > -1) galerien.splice(i, 1);
  }

  var galerienSuchen = sicher(function () {
    if (!erlaubt) return;
    galerien.slice().forEach(function (g) {
      if (!g.el.isConnected || !g.liste.isConnected) loesen(g);
    });
    var gefunden = document.querySelectorAll('product-gallery[data-viv-messung]');
    for (var i = 0; i < gefunden.length; i += 1) {
      var el = gefunden[i];
      var bekannt = galerien.some(function (g) { return g.el === el; });
      if (!bekannt) binden(el);
    }
  });

  function zoomMelden(g, d) {
    if (!erlaubt) return;
    var bild = d.offen && d.bild && d.bild.tagName === 'IMG' ? d.bild : null;
    var id = bild && d.mediaId ? String(d.mediaId) : null;
    if (g.zoomBild && g.zoomBild !== bild) {
      kandidaten.delete(g.zoomBild);
    }
    g.zoomBild = id ? bild : null;
    if (g.zoomBild && !kandidaten.has(bild)) {
      kandidaten.set(bild, { galerie: g, mediaId: id, zoom: true, seit: null, erledigt: false });
    }
    planen(0);
  }

  // ---------------------------------------------------------------- Geometrie

  function rechteck(x, y, b, h) {
    return { x: x, y: y, b: b, h: h };
  }

  function schnitt(a, c) {
    var x = Math.max(a.x, c.x);
    var y = Math.max(a.y, c.y);
    var r = Math.min(a.x + a.b, c.x + c.b);
    var u = Math.min(a.y + a.h, c.y + c.h);
    if (r <= x || u <= y) return null;
    return rechteck(x, y, r - x, u - y);
  }

  function positionsAnteil(wert, achse) {
    var teile = String(wert || '').split(/\s+/);
    var t = teile[achse] || '50%';
    if (/%$/.test(t)) return parseFloat(t) / 100;
    if (t === 'left' || t === 'top') return 0;
    if (t === 'right' || t === 'bottom') return 1;
    return 0.5;
  }

  // Die Flaeche, auf der das Bild selbst gemalt ist (ohne Leerraum von object-fit contain).
  function bildFlaeche(img) {
    var r = img.getBoundingClientRect();
    var f = rechteck(r.left, r.top, r.width, r.height);
    if (!(f.b > 0 && f.h > 0)) return null;
    var st = getComputedStyle(img);
    var fit = st.objectFit;
    var nb = img.naturalWidth;
    var nh = img.naturalHeight;
    if ((fit === 'contain' || fit === 'scale-down') && nb > 0 && nh > 0) {
      var s = Math.min(f.b / nb, f.h / nh);
      if (fit === 'scale-down') s = Math.min(s, 1);
      var b = nb * s;
      var h = nh * s;
      f = rechteck(
        f.x + (f.b - b) * positionsAnteil(st.objectPosition, 0),
        f.y + (f.h - h) * positionsAnteil(st.objectPosition, 1),
        b, h
      );
    }
    return f;
  }

  function sichtbarerTeil(img, flaeche) {
    var fenster = rechteck(0, 0, document.documentElement.clientWidth || window.innerWidth, window.innerHeight);
    var teil = schnitt(flaeche, fenster);
    var el = img.parentElement;
    while (teil && el && el !== document.body && el !== document.documentElement) {
      var st = getComputedStyle(el);
      if (st.overflowX !== 'visible' || st.overflowY !== 'visible') {
        var r = el.getBoundingClientRect();
        teil = schnitt(teil, rechteck(r.left, r.top, r.width, r.height));
      }
      if (st.position === 'fixed') break;
      el = el.parentElement;
    }
    return teil;
  }

  function eigenes(treffer, img, k) {
    if (!treffer) return false;
    if (treffer === img) return true;
    if (k.zoom) {
      var pswp = img.closest('.pswp');
      return !!(pswp && pswp.contains(treffer));
    }
    return k.galerie.el.contains(treffer);
  }

  function gesehenGerade(img, k) {
    if (document.visibilityState !== 'visible') return false;
    if (!img.isConnected || !img.complete || !(img.naturalWidth > 0)) return false;
    if (!k.zoom && img.closest('[hidden]')) return false;
    if (typeof img.checkVisibility === 'function' &&
        !img.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
    var f = bildFlaeche(img);
    if (!f) return false;
    var ganz = f.b * f.h;
    var teil = sichtbarerTeil(img, f);
    if (!teil) return false;
    var sicht = teil.b * teil.h;
    if (sicht < ANTEIL * ganz) return false;
    var frei = 0;
    for (var i = 0; i < RASTER; i += 1) {
      for (var j = 0; j < RASTER; j += 1) {
        var x = teil.x + (i + 0.5) * teil.b / RASTER;
        var y = teil.y + (j + 0.5) * teil.h / RASTER;
        if (eigenes(document.elementFromPoint(x, y), img, k)) frei += 1;
      }
    }
    return sicht * frei / (RASTER * RASTER) >= ANTEIL * ganz;
  }

  // ---------------------------------------------------------------- Takt

  function planen(ms) {
    if (!erlaubt || takt || !kandidaten.size) return;
    takt = setTimeout(schlagen, ms);
  }

  function sekundenNeu() {
    kandidaten.forEach(function (k) {
      k.seit = null;
      k.erledigt = false;
    });
  }

  var schlagen = sicher(function () {
    takt = null;
    if (!erlaubt) return;
    if (!einwilligung()) {
      abbauen();
      return;
    }
    if (document.visibilityState !== 'visible') {
      sekundenNeu();
      return;
    }
    var t = jetzt();
    var offen = false;
    kandidaten.forEach(function (k, img) {
      if (k.erledigt) return;
      if (!k.galerie.el.isConnected) {
        kandidaten.delete(img);
        gruppenPlanen();
        return;
      }
      offen = true;
      if (!gesehenGerade(img, k)) {
        k.seit = null;
        return;
      }
      if (k.seit === null) {
        k.seit = t;
      } else if (t - k.seit >= DAUER_MS) {
        k.erledigt = true;
        gesehen(k);
      }
    });
    if (offen) planen(TAKT_MS);
  });

  function gesehen(k) {
    var g = k.galerie;
    var id = k.mediaId;
    if (!id || g.gruppeIds.indexOf(id) === -1) return;
    var handle = g.handle;
    var gruppe = g.gruppe;
    var p = produkt(handle);
    if (!p.gesehen[id]) {
      p.gesehen[id] = 1;
      p.anzahl += 1;
      var n = p.anzahl;
      var bildZurueck = function () {
        if (!p.gesehen[id]) return;
        delete p.gesehen[id];
        p.anzahl -= 1;
      };
      if (!event(EVENT.bild, 'bild|' + handle + '|' + id, bildZurueck)) {
        bildZurueck();
        return;
      }
      tag(TAG.bild, handle + '|' + id);
      tag(TAG.anzahl, handle + '|' + (n < 10 ? '0' : '') + n);
    }
    if (id === g.letzteId && !p.letztesGruppen[gruppe]) {
      p.letztesGruppen[gruppe] = 1;
      var letztesZurueck = function () { delete p.letztesGruppen[gruppe]; };
      if (!event(EVENT.letztes, 'letztes|' + handle + '|' + gruppe, letztesZurueck)) {
        letztesZurueck();
        return;
      }
      tag(TAG.letztes, handle);
    }
    if (g.gruppeIds.length && !p.alleGruppen[gruppe] &&
        g.gruppeIds.every(function (x) { return p.gesehen[x]; })) {
      p.alleGruppen[gruppe] = 1;
      var alleZurueck = function () { delete p.alleGruppen[gruppe]; };
      if (!event(EVENT.alle, 'alle|' + handle + '|' + gruppe, alleZurueck)) {
        alleZurueck();
        return;
      }
      tag(TAG.alle, handle);
    }
  }

  var sichtwechsel = sicher(function (eintraege) {
    eintraege.forEach(function (e) {
      var img = e.target;
      var g = bildZuGalerie.get(img);
      if (!g) return;
      if (e.isIntersecting) {
        var k = kandidaten.get(img);
        if (!k) {
          var slide = img.closest('.product-gallery__media');
          kandidaten.set(img, {
            galerie: g,
            mediaId: slide ? slide.getAttribute('data-media-id') : null,
            zoom: false,
            seit: null,
            erledigt: false
          });
        } else if (!k.erledigt && k.seit !== null &&
                   (e.intersectionRatio < ANTEIL || !gesehenGerade(img, k))) {
          // Sichtbarkeit hat sich zwischen zwei Takten geaendert und liegt (jetzt oder im
          // gemeldeten Zustand) unter der Schwelle: die laufende Sekunde gilt nicht mehr.
          // Der rohe IO-Anteil misst den Rahmen; bei object-fit contain kann das Bild selbst
          // dabei noch ueber 50 % liegen — dann wird bewusst vorsichtig neu gezaehlt.
          k.seit = null;
        }
      } else {
        kandidaten.delete(img);
      }
    });
    planen(0);
  });

  // ---------------------------------------------------------------- Start / Abbau

  function starten() {
    var stufen = [];
    for (var i = 0; i <= 20; i += 1) stufen.push(i / 20);
    io = new IntersectionObserver(sichtwechsel, { threshold: stufen });
    galerienSuchen();
    planen(0);
  }

  // Widerruf, Fehler oder fehlende Einwilligung beim Senden: Beobachtung, laufende Sekunden und
  // alles noch nicht an Clarity Uebergebene sofort weg (samt Senden-Marke und Zaehlstand dafuer).
  // Was schon uebergeben ist (gesehene Bild-IDs, Zaehlstand, fertige Gruppen, Senden-Marken; keine
  // Personendaten), bleibt bis zum Ende des Seitenaufrufs: eine erneute Einwilligung zaehlt dort
  // weiter und meldet nichts doppelt.
  function abbauen() {
    erlaubt = false;
    if (takt) clearTimeout(takt);
    takt = null;
    if (gruppenTimer) clearTimeout(gruppenTimer);
    gruppenTimer = null;
    if (pufferTimer) clearTimeout(pufferTimer);
    pufferTimer = null;
    galerien.slice().forEach(loesen);
    galerien = [];
    if (io) io.disconnect();
    io = null;
    bildZuGalerie.clear();
    kandidaten.clear();
    pufferVerwerfen();
    pufferVersuche = 0;
  }

  // ---------------------------------------------------------------- Anschluss

  var neuAufbau = sicher(function () {
    // Seiten-Neuaufbau (Variante, anderes Produkt): erst nach dem Austausch suchen.
    setTimeout(sicher(function () {
      galerienSuchen();
      gruppenPlanen();
    }), 0);
  });

  var sichtbarkeit = sicher(function () {
    if (document.visibilityState !== 'visible') {
      sekundenNeu();
    } else {
      planen(0);
    }
  });

  var groesse = sicher(function () {
    gruppenPlanen();
    planen(0);
  });

  var seiteVersteckt = sicher(function () {
    sekundenNeu();
    if (takt) clearTimeout(takt);
    takt = null;
  });

  var seiteGezeigt = sicher(function (e) {
    if (e && e.persisted) pruefeEinwilligung(true);
  });

  var los = sicher(function () {
    if (window.Shopify && window.Shopify.designMode) return;
    if (typeof IntersectionObserver !== 'function' || typeof MutationObserver !== 'function' ||
        typeof Map !== 'function' || typeof document.elementFromPoint !== 'function') return;
    document.addEventListener('visitorConsentCollected', function () { pruefeEinwilligung(true); });
    document.addEventListener('product:rerender', neuAufbau, true);
    document.addEventListener('visibilitychange', sichtbarkeit);
    window.addEventListener('resize', groesse, { passive: true });
    window.addEventListener('pagehide', seiteVersteckt);
    window.addEventListener('pageshow', seiteGezeigt);
    apiNachladen();
    pruefeEinwilligung(false);
  });

  los();
})();
